import {spawnErrorToast} from '@hm/fundamental'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {useRefraQuery} from '@refra/modules/common/hooks'
import {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

interface useStaticPartsListQueryParams {
  plantUpmId: string
  kilnUpmId: string
  shutdownId?: string
}

export const useStaticPartsListQuery = ({
  plantUpmId,
  kilnUpmId,
  shutdownId
}: useStaticPartsListQueryParams) => {
  const {t} = useTranslation()

  return useRefraQuery({
    queryKey: 'staticPartsList',
    params: [{plantUpmId, kilnUpmId, shutdownId}],
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useStaticPartsListQuery')
        .extras({errorDetails, plantUpmId, kilnUpmId})
        .error('Error occurred while fetching drilling settings')

      spawnErrorToast(t('error.staticPartsList'))

      return false
    }
  })
}
